<template>
  <router-view/>
  <FloatingCart />
</template>

<script setup lang="ts">
import FloatingCart from '@/components/FloatingCart.vue';
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}
html {
  scrollbar-gutter: stable;
}
body {
  margin: 0;
  overflow-y: scroll;
}

// 移动端防止横向溢出导致的滚动条，并防止 Element Plus dialog 锁定 body 产生残影
@media screen and (max-width: 768px) {
  html {
    scrollbar-gutter: auto;
    overflow-x: hidden;
    overflow-y: auto; // 确保 html 元素不强制保留滚动条空间
  }
  body {
    overflow-y: auto;
    overflow-x: hidden;
    // 确保 Element Plus dialog 残留的 padding-right/overflow:hidden 不影响布局
    padding-right: 0 !important;
  }
}

// 自定义登录提示弹出框样式
.custom-login-prompt {
  width: 420px !important;
  border-radius: 12px !important;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15) !important;
  
  @media screen and (max-width: 768px) {
    width: 90% !important;
    max-width: 420px !important;
  }
  
  .el-message-box__header {
    padding: 24px 24px 16px !important;
    
    .el-message-box__title {
      font-size: 18px !important;
      font-weight: 600 !important;
      color: #1f2937 !important;
    }
  }
  
  .el-message-box__content {
    padding: 16px 24px 24px !important;
    
    .el-message-box__container {
      .el-message-box__message {
        font-size: 15px !important;
        line-height: 1.6 !important;
        color: #4b5563 !important;
      }
    }
  }
  
  .el-message-box__btns {
    padding: 16px 24px 24px !important;
    
    .el-button {
      padding: 10px 24px !important;
      border-radius: 8px !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      min-width: 88px !important;
      transition: all 0.2s ease !important;
      
      &.el-button--default {
        background-color: #f3f4f6 !important;
        border-color: #e5e7eb !important;
        color: #6b7280 !important;
        
        &:hover {
          background-color: #e5e7eb !important;
          border-color: #d1d5db !important;
          color: #4b5563 !important;
        }
      }
      
      &.el-button--primary {
        background-color: #b91c1c !important;
        border-color: #b91c1c !important;
        box-shadow: 0 2px 8px rgba(185, 28, 28, 0.2) !important;
        
        &:hover {
          background-color: #991b1b !important;
          border-color: #991b1b !important;
          box-shadow: 0 4px 12px rgba(185, 28, 28, 0.3) !important;
          transform: translateY(-1px);
        }
        
        &:active {
          transform: translateY(0);
        }
      }
    }
  }
}

// 用户头像下拉菜单样式
.el-dropdown-menu {
  padding: 8px !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid #e5e7eb !important;
  
  .el-dropdown-menu__item {
    padding: 12px 16px !important;
    border-radius: 8px !important;
    font-size: 14px !important;
    color: #4b5563 !important;
    transition: all 0.2s ease !important;
    display: flex !important;
    align-items: center !important;
    gap: 10px !important;
    
    .el-icon {
      font-size: 16px !important;
      color: #6b7280 !important;
      transition: color 0.2s ease !important;
    }
    
    &:hover {
      background-color: #f9fafb !important;
      color: #b91c1c !important;
      
      .el-icon {
        color: #b91c1c !important;
      }
    }
    
    &.is-divided {
      margin-top: 8px !important;
      padding-top: 12px !important;
      border-top: 1px solid #f3f4f6 !important;
      
      &:hover {
        background-color: #fff5f5 !important;
      }
    }
  }
}
</style>
